/**
 * Centralised location for checkout generic data updates
 */
import { ICheckoutState } from '@msdyn365-commerce/global-state';
import { ICoreContext } from '@msdyn365-commerce/core';
import { Address } from '@msdyn365-commerce/retail-proxy';
import { _readFromSessionStorage, _readFromStorage, _writeToSessionStorage, _writeToStorage } from '../../utils/helper';

const CENTIRO_ADDRESS: string = 'bsCentiroDeliveryAddress';

export interface CentiroDeliveryAddress extends Address {
    ExternalId: string;
}

export const setCentiroAddress = (centiroAddress: Address, expirationDays?: number) => {
    _writeToSessionStorage(CENTIRO_ADDRESS, JSON.stringify(centiroAddress), expirationDays);
};
export const getCentiroAddress = (): CentiroDeliveryAddress | undefined => {
    const data = _readFromSessionStorage(CENTIRO_ADDRESS);
    if (data) {
        return JSON.parse(data) as CentiroDeliveryAddress;
    }
    return undefined;
};

export const cartContainsItemsForCentiroShipping = (checkout: ICheckoutState | undefined, context: ICoreContext): boolean => {
    const centiroDeliveryMode: string = context.request.app.config.deliveryModeCentiro?.toLowerCase() || 'postnord';
    return !!((checkout && checkout.checkoutCart.cart.CartLines) || []).filter(cartLine =>
        cartLine.DeliveryMode && cartLine.DeliveryMode !== ''
            ? cartLine.DeliveryMode === centiroDeliveryMode && cartLine.DeliveryMode === centiroDeliveryMode
            : false
    );
};
